<template>
  <van-field class="custom-switch-field">
    <template #input>
      <div class="flex-between">
        <div class="switch-item flex-start" :class="{ active: switchType === '1' }" @click="switchType = '1'">
          <svg-icon icon-name="pw-lock" :width="50" current-color />
          <span class="ml_12">{{ text1 }}</span>
        </div>
        <div class="switch-item flex-end" :class="{ active: switchType === '2' }" @click="switchType = '2'">
          <svg-icon icon-name="code-lock" :width="50" current-color />
          <span class="ml_12">{{ text2 }}</span>
        </div>
      </div>
    </template>
  </van-field>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

type Props = {
  type: 'login' | 'register';
};

const props = withDefaults(defineProps<Props>(), {
  type: 'login',
});

const switchType = defineModel<string>();
// const switchType = ref<'1' | '2'>('1'); // 密码或者验证码登录

const text1 = computed(() => {
  return props.type === 'login' ? '密码登录' : '密码注册';
});

const text2 = computed(() => {
  return props.type === 'login' ? '验证码登录' : '验证码注册';
});
</script>

<style lang="less" scoped>
.custom-switch-field {
  padding: 0 var(--van-cell-horizontal-padding);

  :deep(.van-field__body) {
    height: auto;
  }

  &::after {
    display: none;
  }

  .switch-item {
    &.active {
      color: var(--text-primary-color);

      .svg-icon {
        color: var(--theme-icon-primary-color);
      }
    }
  }
}
</style>
